import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import DokaiLogo from '../../assets/dokai-logo.svg';
import AvatarMenu from './AvatarMenu';
import { URL_PATHNAMES } from '../routes/AppRoutes';

const WebTopbar = () => {
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 1,
        backgroundColor: theme.customColors.themeTertiary
      })}
    >
      <Box
        component={Link}
        to={URL_PATHNAMES.CAMPAIGN}
        sx={{
          display: 'flex',
          alignItems: 'center',
          ml: 2,
          cursor: 'pointer',
          textDecoration: 'none',
          color: 'inherit'
        }}
      >
        <img src={DokaiLogo} alt="Dokai Logo" style={{ height: '32px' }} />
      </Box>

      <AvatarMenu />
    </Box>
  );
};

export default WebTopbar;
